import React from 'react'
import LayoutHorizontal from 'src/apps/Global/components/Nav/LayoutHorizontal'
import { Theme } from 'src/libraries/contexts/Theme'

const GlobalNav = () => (
   <>
      <Theme
         globalNavBackgroundColor="#000"
         globalNavBorderColor="#000"
         globalNavDividerColor="#333"
         globalNavLogoFieldName="logoDefaultNegative"
         globalNavTextColor="#888"
         viewportMarginLeft="0px"
      />
      <LayoutHorizontal />
   </>
)

export default GlobalNav
